import InputAdornment from '@mui/material/InputAdornment';
import { cloneElement } from 'react';
import { Button, TextInput, TextInputProps, useRecordContext, useResourceContext } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { BASE_URL } from 'utils/api';
import fetchJson from 'utils/fetchJson';

export interface ApiKeyInputProps extends TextInputProps {
  length?: number,
  inputProps?: TextInputProps,
}

const ApiKeyInput = (props: ApiKeyInputProps) => {
  const { source, length, inputProps, readOnly, ...rest } = props;
  const resource = useResourceContext();
  const record = useRecordContext();
  const { setValue } = useFormContext();
  // const translate = useTranslate();
  // const [data, setData] = useState([]);

  const ApiKeyGen: () => string = () => btoa(Math.random().toString()).substr(4, length);

  const handleClickShowPassword = async () => {
    let isUnique = false;
    let apiKey = '';
    do {
      apiKey = ApiKeyGen();

      let res = (await fetchJson(BASE_URL + `api/records/${resource}?filter=${source},eq,${apiKey}`)).json;
      if (0 === res.records.length) {
        isUnique = true;
      }
    } while (!isUnique);

    setValue(source, apiKey, { shouldDirty: true });
  }

  return (
    <>
      {cloneElement(<TextInput source={source} InputProps={{
        readOnly: true,
        ...inputProps,
        startAdornment:
          <InputAdornment position="start">
            <Button
              aria-label="Re generate API Key"
              onClick={handleClickShowPassword}
              label="Gen" />
          </InputAdornment>
      }} />, {
          ...rest,
          source: source,
          record: record,
        })}
    </>
  );
}

ApiKeyInput.defaultProps = {
  number: 16,
}

export default ApiKeyInput;
